module.exports = {
	"ha": "bc",
	"id": 5.5,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category and MSM Status, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.31901840490798,
						"dataLabels": {
							"enabled": false,
							"format": "157"
						},
						"color": "#043f61"
					},
					{
						"y": 85.88957055214725,
						"dataLabels": {
							"enabled": false,
							"format": "140"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.20858895705521,
						"dataLabels": {
							"enabled": false,
							"format": "134"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.61963190184049,
						"dataLabels": {
							"enabled": false,
							"format": "120"
						},
						"color": "#09472e"
					},
					{
						"y": 59.50920245398773,
						"dataLabels": {
							"enabled": false,
							"format": "97"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.0701754385965,
						"dataLabels": {
							"enabled": false,
							"format": "559"
						},
						"color": "#043f61"
					},
					{
						"y": 82.80701754385966,
						"dataLabels": {
							"enabled": false,
							"format": "472"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.42105263157895,
						"dataLabels": {
							"enabled": false,
							"format": "447"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.75438596491229,
						"dataLabels": {
							"enabled": false,
							"format": "409"
						},
						"color": "#09472e"
					},
					{
						"y": 52.63157894736842,
						"dataLabels": {
							"enabled": false,
							"format": "300"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.03225806451613,
						"dataLabels": {
							"enabled": false,
							"format": "614"
						},
						"color": "#043f61"
					},
					{
						"y": 86.7741935483871,
						"dataLabels": {
							"enabled": false,
							"format": "538"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.3225806451613,
						"dataLabels": {
							"enabled": false,
							"format": "498"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.35483870967742,
						"dataLabels": {
							"enabled": false,
							"format": "461"
						},
						"color": "#09472e"
					},
					{
						"y": 54.677419354838705,
						"dataLabels": {
							"enabled": false,
							"format": "339"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "2487"
						},
						"color": "#043f61"
					},
					{
						"y": 90.06835544833133,
						"dataLabels": {
							"enabled": false,
							"format": "2240"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.16284680337756,
						"dataLabels": {
							"enabled": false,
							"format": "2118"
						},
						"color": "#0d4440"
					},
					{
						"y": 81.70486529955771,
						"dataLabels": {
							"enabled": false,
							"format": "2032"
						},
						"color": "#09472e"
					},
					{
						"y": 63.852030558906314,
						"dataLabels": {
							"enabled": false,
							"format": "1588"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 98.57142857142858,
						"dataLabels": {
							"enabled": false,
							"format": "69"
						},
						"color": "#043f61"
					},
					{
						"y": 88.57142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "62"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.85714285714286,
						"dataLabels": {
							"enabled": false,
							"format": "58"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "46"
						},
						"color": "#09472e"
					},
					{
						"y": 45.714285714285715,
						"dataLabels": {
							"enabled": false,
							"format": "32"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.6013986013986,
						"dataLabels": {
							"enabled": false,
							"format": "282"
						},
						"color": "#043f61"
					},
					{
						"y": 91.6083916083916,
						"dataLabels": {
							"enabled": false,
							"format": "262"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.21678321678321,
						"dataLabels": {
							"enabled": false,
							"format": "238"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.78321678321679,
						"dataLabels": {
							"enabled": false,
							"format": "191"
						},
						"color": "#09472e"
					},
					{
						"y": 40.55944055944056,
						"dataLabels": {
							"enabled": false,
							"format": "116"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.35329341317365,
						"dataLabels": {
							"enabled": false,
							"format": "657"
						},
						"color": "#043f61"
					},
					{
						"y": 87.12574850299401,
						"dataLabels": {
							"enabled": false,
							"format": "582"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.03592814371258,
						"dataLabels": {
							"enabled": false,
							"format": "548"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.7065868263473,
						"dataLabels": {
							"enabled": false,
							"format": "479"
						},
						"color": "#09472e"
					},
					{
						"y": 42.51497005988024,
						"dataLabels": {
							"enabled": false,
							"format": "284"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.71910112359551,
						"dataLabels": {
							"enabled": false,
							"format": "1775"
						},
						"color": "#043f61"
					},
					{
						"y": 88.48314606741573,
						"dataLabels": {
							"enabled": false,
							"format": "1575"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.37078651685394,
						"dataLabels": {
							"enabled": false,
							"format": "1484"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.51685393258427,
						"dataLabels": {
							"enabled": false,
							"format": "1362"
						},
						"color": "#09472e"
					},
					{
						"y": 49.8876404494382,
						"dataLabels": {
							"enabled": false,
							"format": "888"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 48.507462686567166,
						"dataLabels": {
							"enabled": false,
							"format": "130"
						},
						"color": "#043f61"
					},
					{
						"y": 39.55223880597015,
						"dataLabels": {
							"enabled": false,
							"format": "106"
						},
						"color": "#0c4250"
					},
					{
						"y": 35.82089552238806,
						"dataLabels": {
							"enabled": false,
							"format": "96"
						},
						"color": "#0d4440"
					},
					{
						"y": 30.970149253731343,
						"dataLabels": {
							"enabled": false,
							"format": "83"
						},
						"color": "#09472e"
					},
					{
						"y": 13.805970149253731,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 87.03241895261846,
						"dataLabels": {
							"enabled": false,
							"format": "349"
						},
						"color": "#043f61"
					},
					{
						"y": 66.08478802992519,
						"dataLabels": {
							"enabled": false,
							"format": "265"
						},
						"color": "#0c4250"
					},
					{
						"y": 61.84538653366584,
						"dataLabels": {
							"enabled": false,
							"format": "248"
						},
						"color": "#0d4440"
					},
					{
						"y": 55.61097256857855,
						"dataLabels": {
							"enabled": false,
							"format": "223"
						},
						"color": "#09472e"
					},
					{
						"y": 39.40149625935162,
						"dataLabels": {
							"enabled": false,
							"format": "158"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 87.89013732833958,
						"dataLabels": {
							"enabled": false,
							"format": "704"
						},
						"color": "#043f61"
					},
					{
						"y": 64.16978776529338,
						"dataLabels": {
							"enabled": false,
							"format": "514"
						},
						"color": "#0c4250"
					},
					{
						"y": 57.05368289637952,
						"dataLabels": {
							"enabled": false,
							"format": "457"
						},
						"color": "#0d4440"
					},
					{
						"y": 52.30961298377028,
						"dataLabels": {
							"enabled": false,
							"format": "419"
						},
						"color": "#09472e"
					},
					{
						"y": 37.578027465667915,
						"dataLabels": {
							"enabled": false,
							"format": "301"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 86.34471273938385,
						"dataLabels": {
							"enabled": false,
							"format": "2074"
						},
						"color": "#043f61"
					},
					{
						"y": 55.661948376353045,
						"dataLabels": {
							"enabled": false,
							"format": "1337"
						},
						"color": "#0c4250"
					},
					{
						"y": 50.62447960033306,
						"dataLabels": {
							"enabled": false,
							"format": "1216"
						},
						"color": "#0d4440"
					},
					{
						"y": 47.87676935886761,
						"dataLabels": {
							"enabled": false,
							"format": "1150"
						},
						"color": "#09472e"
					},
					{
						"y": 37.302248126561196,
						"dataLabels": {
							"enabled": false,
							"format": "896"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.6809815950920255,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.828025477707005,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.285714285714281,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.447761194029848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.166666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.9298245614035037,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.563506261180681,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.296610169491522,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.501118568232657,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.650366748166256,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.9677419354838679,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.377850162866455,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.434944237918217,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.429718875502012,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.464208242950104,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.931644551668672,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.446428571428575,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.060434372049104,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.850393700787397,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -1.4285714285714235,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.144927536231885,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.68965517241379,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.434782608695656,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.3986013986013957,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.092198581560282,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.160305343511455,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.747899159663863,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -39.26701570680628,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.646706586826352,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.415525114155257,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.841924398625431,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.591240875912412,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40.7098121085595,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.2808988764044895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.267605633802813,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.777777777777782,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.221024258760112,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.801762114537446,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -51.49253731343284,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.461538461538463,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.433962264150942,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.541666666666663,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -55.42168674698795,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -12.967581047381548,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.068767908309454,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.41509433962264,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.080645161290324,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.147982062780265,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -12.109862671660421,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.988636363636363,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.08949416342413,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.315098468271332,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.16229116945107,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -13.655287260616156,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.53519768563162,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.050112191473447,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.427631578947367,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.086956521739133,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=163"
			},
			{
				"x": 9,
				"text": "30-39<br>n=570"
			},
			{
				"x": 15,
				"text": "40-49<br>n=620"
			},
			{
				"x": 21,
				"text": ">=50<br>n=2487"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=70"
			},
			{
				"x": 34,
				"text": "30-39<br>n=286"
			},
			{
				"x": 40,
				"text": "40-49<br>n=668"
			},
			{
				"x": 46,
				"text": ">=50<br>n=1780"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=268"
			},
			{
				"x": 59,
				"text": "30-39<br>n=401"
			},
			{
				"x": 65,
				"text": "40-49<br>n=801"
			},
			{
				"x": 71,
				"text": ">=50<br>n=2402"
			}
		],
		"dataTable": {
			"MSM:<30": [
				163,
				157,
				140,
				134,
				120,
				97
			],
			"MSM:30-39": [
				570,
				559,
				472,
				447,
				409,
				300
			],
			"MSM:40-49": [
				620,
				614,
				538,
				498,
				461,
				339
			],
			"MSM:>=50": [
				2487,
				2487,
				2240,
				2118,
				2032,
				1588
			],
			"Non-MSM:<30": [
				70,
				69,
				62,
				58,
				46,
				32
			],
			"Non-MSM:30-39": [
				286,
				282,
				262,
				238,
				191,
				116
			],
			"Non-MSM:40-49": [
				668,
				657,
				582,
				548,
				479,
				284
			],
			"Non-MSM:>=50": [
				1780,
				1775,
				1575,
				1484,
				1362,
				888
			],
			"Unknown:<30": [
				268,
				130,
				106,
				96,
				83,
				37
			],
			"Unknown:30-39": [
				401,
				349,
				265,
				248,
				223,
				158
			],
			"Unknown:40-49": [
				801,
				704,
				514,
				457,
				419,
				301
			],
			"Unknown:>=50": [
				2402,
				2074,
				1337,
				1216,
				1150,
				896
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_5.json
// module id = 170
// module chunks = 0